import { useCallback, useState } from 'react';
import { useAppDispatch } from 'shared/hooks';
import { updateOpenedFilter } from 'shared/slices/searchMetaTooltip';
import { TFilter } from 'shared/types/filters';

export const useDropdown = (filterKey: TFilter) => {
  const dispatch = useAppDispatch();
  const [opened, setIsOpened] = useState(false);

  const handleClose = useCallback(() => {
    setIsOpened(false);
    dispatch(updateOpenedFilter(null));
  }, [dispatch]);

  const handleOpen = useCallback(() => {
    setIsOpened(true);
    dispatch(updateOpenedFilter(filterKey));
  }, [dispatch, filterKey]);

  return { opened, onClose: handleClose, onOpen: handleOpen };
};
